/**
 * @generated SignedSource<<05d9cb4572b3d4406a57fa40c72ba49e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageSectionSidebarBanner_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullHeight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "autoplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slidesInterval",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Slide",
      "kind": "LinkedField",
      "name": "slides",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Slide_slide"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSidebarSectionTitle_pageSection"
    }
  ],
  "type": "PageSectionSidebarBanner",
  "abstractKey": null
};

node.hash = "6d4c54f9245bb6cfc2ce12fefd51e27e";

module.exports = node;
